import React from 'react';
import { CONTACT_URL } from '../constants';

export default function Header() {
  return (
    <header className="site-header">
      <div className="site-header__inner">
        <a href="/" className="brand">
          <img src="/logo.png" alt="" className="brand__logo" />
          ConvoLines
        </a>
        <a href={CONTACT_URL} target="_blank" rel="noreferrer" className="btn btn--ghost btn--small">
          Contact
        </a>
      </div>
    </header>
  );
}
